<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ sprintToEdit.id ? $t('sprint.addEdit.titleEdit') : $t('sprint.addEdit.titleAdd') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <information-msg-component
        v-if="sprintToEdit.id"
        :title="'general.info'"
        :libelleList="[{ isLink: false, libelle: $t('sprint.addEdit.updateSprintConfirmation') }]"
        :canClose="false"/>
      <error-msg-component
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVides"
        :messages="messages"
        :error="error"
        @close="error = $event"
        title="general.problemOccurred"
        withEmplyFields/>
      <div class="columns is-multiline">
        <b-field
          :label="$t('sprint.addEdit.titre')"
          class="column is-12 mgb-0 obligatoire">
          <b-input v-model.trim="sprintToEdit.titre"/>
        </b-field>
        <b-field
          :label="$t('sprint.addEdit.dateAffichage')"
          class="column is-6 mgb-0 obligatoire">
          <b-datepicker
            v-model="sprintToEdit.dateAffichage"
            :max-date="sprintToEdit.dateRetraitHomePage"
            icon="calendar-today"
            nearby-selectable-month-days
            show-week-number
            editable>
          </b-datepicker>
        </b-field>
        <b-field
          :label="$t('sprint.addEdit.dateRetraitHomePage')"
          class="column is-6 mgb-0 obligatoire">
          <b-datepicker
            v-model="sprintToEdit.dateRetraitHomePage"
            :min-date="sprintToEdit.dateAffichage"
            icon="calendar-today"
            nearby-selectable-month-days
            show-week-number
            editable>
          </b-datepicker>
        </b-field>
        <b-field
          :label="$t('sprint.addEdit.sprint')"
          class="column is-12 mgb-0 obligatoire">
          <b-input
            v-model.trim="sprintToEdit.sprint"
            type="textarea"
            row="3"/>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <button class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </button>
          </div>
          <div class="is-pulled-left boutonAction">
            <button class="button is-addOrEdit" @click="save()">
              {{ $t('general.button.sauvegarder') }}
            </button>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>
<script>
import { create, update } from '@/api/sprint';
import validation, { removeDuplicateMsgError } from '@/services/validation/validation';
import messageErreur from '@/services/general/messageErreur';
import formatIsoDate from '@/services/general/formatIsoDate';
import messageSuccess from '@/services/general/messageSucces';
import translate from '@/services/parametrage/translator/translatorSprint';
import genererSprint from '@/services/parametrage/generation/genererSprint';
import ErrorMsgComponent from '@/components/general/errorMsgComponent';
import InformationMsgComponent from '@/components/general/informationMsgComponent';

export default {
  name: 'PAddEditSprint',
  props: {
    sprint: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    ErrorMsgComponent,
    InformationMsgComponent,
  },
  data() {
    return {
      sprintToEdit: genererSprint(),
      messagesChampsVide: [],
      champsVides: [],
      messages: [],
      error: false,
    };
  },
  methods: {
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      this.error = false;
      this.messages = [];
      this.champsVides = [];
      this.messagesChampsVide = [];
      try {
        const sprint = {
          ...this.sprintToEdit,
          dateAffichage: formatIsoDate(this.sprintToEdit.dateAffichage),
          dateRetraitHomePage: formatIsoDate(this.sprintToEdit.dateRetraitHomePage),
        };
        if (sprint.id) {
          await update(sprint);
          messageSuccess(this.$t('sprint.addEdit.editSprintSuccess'));
        } else {
          await create(sprint);
          messageSuccess(this.$t('sprint.addEdit.addSprintSuccess'));
        }
        this.$emit('reload');
        this.$parent.close();
      } catch (e) {
        this.error = true;
        if (e.response?.data?.error?.validationErrors) {
          validation(this.$i18n, e.response, this.champsVides,
            this.messages, this.messagesChampsVide, translate);
          this.messages = removeDuplicateMsgError(this.messages);
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  mounted() {
    if (this.sprint) {
      this.sprintToEdit = {
        ...this.sprint,
        dateAffichage: new Date(this.sprint.dateAffichage),
        dateRetraitHomePage: new Date(this.sprint.dateRetraitHomePage),
      };
    }
  },
};
</script>
